module.exports = __webpack_public_path__ + "static/img/边框13.5f7553e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框13.svg
// module id = y0YB
// module chunks = 2